var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldDollar = function SvgShieldDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 21.48q-3.244-.884-5.372-3.818T4.5 11.1V5.346L12 2.54l7.5 2.807V11.1q0 3.627-2.128 6.562Q15.244 20.596 12 21.48m0-1.58q2.6-.825 4.3-3.3t1.7-5.5V6.375l-6-2.24-6 2.24V11.1q0 3.025 1.7 5.5t4.3 3.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.923 16.5h-1.5v-1h-2V14h4v-1.5h-3.25a.73.73 0 0 1-.535-.215.73.73 0 0 1-.215-.535v-3q0-.319.215-.534A.73.73 0 0 1 10.173 8h1.25V7h1.5v1h2v1.5h-4V11h3.25q.32 0 .535.216a.73.73 0 0 1 .215.534v3a.73.73 0 0 1-.215.535.73.73 0 0 1-.535.215h-1.25z"
  })));
};
export default SvgShieldDollar;